export default __webpack_public_path__ + "images/c15a16304a27fbaaf0d7d4f98e0c7d25-badge-pyxir-chat.svg";